<template>
  <div>
    <l-tables
      :tableConfig="tableConfig"
      ref="childRef"
      :searchParams="searchData"
      :noCreatText="$t('admin.favorites.noData')"
      :ImgSrc="nullImg"
      @tableChange="handleTableHeaderChange"
    >
      <template slot="searchConditions">
        <a-input v-model="keyword" @change="search" maxlength="30" :placeholder="$t('admin.favorites.placeholder')">
          <img slot="prefix" :src="require('@/assets/icons/icon_ss.png')" />
          <img
            class="clear"
            v-if="keyword"
            slot="suffix"
            @click=";(keyword = undefined), search()"
            :src="require('@/assets/icons/icon_gb.png')"
          />
        </a-input>
      </template>
      <template #targetUrl="{ record }">
        <a-tooltip>
          <template slot="title">
            <div>{{ record.targetUrl }}</div>
          </template>
          <div class="ellipsis">{{ record.targetUrl }}</div>
        </a-tooltip>
      </template>
      <template #operates="{ record }">
        <div class="operate">
          <a-button type="link" style="padding-right: 0" @click="goDetail(record)">
            {{ $t('admin.favorites.actions.viewDetails') }}
          </a-button>
        </div>
      </template>
    </l-tables>
  </div>
</template>

<script>
import LTables from '@/components/LTables/index.vue'
import {
  resourceTypeMap
} from '@/api/admin'
let att = []
export default {
  components: {
    LTables
  },
  data() {
    return {
      nullImg: require('@/assets/img/trainningAppointmentListNull.png'),
      keyword: undefined,
      searchData: {
        keyword: ''
      },
      tableConfig: {
        tableName: this.$t('admin.favorites.title'),
        tableColumns: [
          {
            title: this.$t('admin.favorites.columns.index'),
            dataIndex: 'index',
            key: 'index',
            align: 'center',
            width: 80
          },
          {
            title: this.$t('admin.favorites.columns.resourceType'),
            dataIndex: 'typeName',
            key: 'typeName',
            align: 'center',
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filterMultiple: false,
            filters: [
              { text: this.$t('admin.favorites.resourceTypes.course'), value: '1' },
              { text: this.$t('admin.favorites.resourceTypes.sharedResource'), value: '2' },
              { text: this.$t('admin.favorites.resourceTypes.personalResource'), value: '3' },
              { text: this.$t('admin.favorites.resourceTypes.schoolResource'), value: '4' }
            ]
          },
          {
            title: this.$t('admin.favorites.columns.resourceType'),
            dataIndex: 'subTypeName',
            key: 'subTypeName',
            align: 'center',
            filterMultiple: false,
            filterIcon: filtered => this.$createElement('filter-icon', { props: { checked: filtered } }),
            filters: []
          },
          {
            title: this.$t('admin.favorites.columns.title'),
            dataIndex: 'title',
            key: 'title',
            align: 'center'
          },
          {
            title: this.$t('admin.favorites.columns.resourceUrl'),
            dataIndex: 'targetUrl',
            key: 'targetUrl',
            align: 'center',
            scopedSlots: { customRender: 'targetUrl' }
          },
          {
            title: this.$t('admin.favorites.columns.likes'),
            dataIndex: 'linkNumber',
            key: 'linkNumber',
            align: 'center'
          },
          {
            title: this.$t('admin.favorites.columns.collections'),
            dataIndex: 'collectNumber',
            key: 'collectNumber',
            align: 'center'
          },
          {
            title: this.$t('admin.favorites.columns.operations'),
            dataIndex: 'operate',
            key: 'operate',
            align: 'center',
            scopedSlots: { customRender: 'operates' }
          }
        ],
        tableDeleteTip: {
          title: this.$t('admin.favorites.deleteConfirm.title'),
          content: this.$t('admin.favorites.deleteConfirm.content')
        },
        tablePort: {
          list: '/admin/interactions/list'
        },
        hideRowSelection: true
      },
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      roomList: [],
      teachList: [],
      filterResult: {},
      filterIconsState: false,
      filterIconState: false
    }
  },
  mounted() {
    this.getResourceTypeMap()
  },
  methods: {
    async getResourceTypeMap () {
      const res = await resourceTypeMap()
      if (res.code == 200) {
        att = []
        for (const item of res.data.list) {
          att.push({
            text: item.name,
            value: item.id
          })
        }
        att.push({
          text: '课程',
          value: 'lesson'
        })
        this.tableConfig.tableColumns[2].filters = att
      }
    },
    search() {
      this.searchData.keyword = this.keyword
    },
    // 上下架
    goDetail(item) {
      this.$router.push({
        name: 'favoritesDetail',
        query: {
          id: item.targetId,
          type: item.type
        }
      })
    },
    deleteClick(id) {
      console.log(id)
      this.$refs.childRef.delModal(id)
    },
    onOk(value) {
      console.log('onOk: ', value)
    },
    handleTableHeaderChange([filters, getList, sorter]) {
      console.log(this.subDate)
      let result = {}
      result = {
        type: filters.typeName,
        subType: filters.subTypeName,
        ...this.subDate,
        ...this.createdDate
      }
      console.log(result)
      this.filterResult = result
      getList({ condition: result })
    }
  }
}
</script>

<style lang="less" scoped>
.l-form {
  /deep/ .ant-form-item {
    margin-bottom: 0 !important;
    width: 250px;
    line-height: 30px;
  }
  .ant-form-item-label {
    margin-top: 10px;
  }
}
/deep/ .ant-table-thead > tr > th .anticon-filter,
.ant-table-thead > tr > th .ant-table-filter-icon {
  right: auto !important;
}
.remark_cla {
  max-width: 200px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
/deep/.ant-modal-wrap .ant-modal .ant-input {
  resize: none; /* 禁止用户手动拖动调整大小 */
}
/deep/ .ant-table-filter-dropdown .ant-dropdown-menu {
  max-height: 319px !important;
  overflow-x: auto !important;
}
.marginBottom0 {
  margin-bottom: 0;
}
/deep/ .ant-form-item-children {
  textarea {
    width: 100% !important;
  }
}
.ellipsis {
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: inline-block;
}
</style>
